
function PanelLoadingController(TranslationService) {    
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();
    this.margin = '100';

}

PanelLoadingController.$inject = ['TranslationService'];

seedWebApp.component('sdProgress', {    
    controller: PanelLoadingController,
    bindings: {        
        loading: '<',
        msg: '<',
        showImage: '<'
    },
    templateUrl: '/SPA/components/sd-progress.html' + seedWebApp.buildVersion
});